import { IMAGE_LOCAL, MODAL_TYPES } from '@/common/constants';
import { isHalfRight, isHalfSheet as isSheetHalfSheet } from '@/common/utils';
import CommonModal from '@/components/Modals/CommonModal';
import {
  useAppCommon,
  useGenerateBackground,
  useModal,
  usePrintBackgroundMenu
} from '@/hooks';
import PopupSelected from '@/components/Modals/MediaSelection/PopupSelected';
import ResultItem from '../ResultItem';
import ExampleItem from '../ExampleItem';

import ConfirmAction from '@/containers/Modals/ConfirmAction';
import { cloneDeep } from 'lodash';

export default {
  components: {
    CommonModal,
    PopupSelected,
    ResultItem,
    ConfirmAction,
    ExampleItem
  },
  data() {
    const exampleItems = [
      {
        thumbnail: IMAGE_LOCAL.BACKGROUND_AI_01,
        des: 'An abstract watercolor sky',
        isSingle: false
      },
      {
        thumbnail: IMAGE_LOCAL.BACKGROUND_AI_02,
        des: 'A blue purple and pink gradient',
        isSingle: true
      },
      {
        thumbnail: IMAGE_LOCAL.BACKGROUND_AI_03,
        des: 'A blackboard with chalk',
        isSingle: false
      }
    ];
    return {
      exampleItems,
      selectedItem: [],
      describe: null,
      desText: null,
      results: null,
      isShowResults: false,
      isGenerateSingle: false,
      isShowSuccessModal: false,
      isOpen: true,
      generatedBackground: null,
      isLoading: false
    };
  },

  setup() {
    const { toggleModal } = useModal();
    const { currentSheet } = usePrintBackgroundMenu();
    const {
      generateBackground,
      saveGeneratedBackground
    } = useGenerateBackground();
    const { generalInfo } = useAppCommon();
    return {
      toggleModal,
      currentSheet,
      generalInfo,
      generateBackground,
      saveGeneratedBackground
    };
  },
  computed: {
    isDisableSelect() {
      return !this.selectedItem.length;
    },
    isDisabledGenBtn() {
      return !this.describe;
    },
    isHalfSheet() {
      return isSheetHalfSheet(this.currentSheet);
    }
  },
  methods: {
    onCancel() {
      this.isShowSuccessModal = false;
      this.toggleModal({
        isOpenModal: false
      });
    },
    onSelect() {
      this.isOpen = false;
      this.isShowSuccessModal = true;
    },
    async onGenerate({ isSingle }) {
      this.isLoading = true;
      this.isShowResults = false;
      this.selectedItem = [];
      this.results = await this.generateBackground({
        describe: this.describe,
        isSingle,
        communityId: this.generalInfo.communityId
      });
      this.desText = this.describe;
      this.describe = null;
      this.isGenerateSingle = isSingle;
      this.isShowResults = true;
      this.isLoading = false;
    },
    onSelectedItem(value) {
      const index = this.selectedItem.findIndex(item => item === value);
      if (index < 0) {
        this.selectedItem = [value];
        return;
      }
      this.selectedItem = [];
    },
    async onSaveOnly() {
      this.generatedBackground = await this.saveGeneratedBackground(
        this.selectedItem,
        this.results.id
      );
      this.onCancel();
    },
    async onSaveAndPlace() {
      await this.onSaveOnly();
      if (!this.generatedBackground) {
        return;
      }

      if (this.isGenerateSingle && !this.isHalfSheet) {
        this.toggleModal({
          isOpenModal: true,
          modalData: {
            type: MODAL_TYPES.BACKGROUND_SELECT_PAGE,
            props: {
              numberPageLeft: this.currentSheet.pageLeftName,
              numberPageRight: this.currentSheet.pageRightName,
              background: {
                ...cloneDeep(this.generatedBackground[0]),
                opacity: 1
              }
            }
          }
        });
        return;
      }

      const isLeft = !isHalfRight(this.currentSheet);

      this.$root.$emit('printAddBackground', {
        background: {
          ...cloneDeep(this.generatedBackground[0]),
          opacity: 1
        },
        isLeft
      });
    }
  }
};
